/******************
* Send and process a remote request (e.g. for newsletter subscription)
*******************/
if(typeof FN == 'undefined') FN = {};

FN.remoteRequest = {
  _resolveElement: function(target) {
    if (!target) return null;
    if (target instanceof Element) return target;
    if (target.length && target[0] instanceof Element) return target[0];
    if (typeof target === 'string') return document.querySelector(target);
    return null;
  },

  sendRequest: function(url, requestData, options){
    var responseContainer = FN.remoteRequest._resolveElement(options.responseContainer);
    if (responseContainer) {
      responseContainer.innerHTML = 'Your request is being submitted...';
      responseContainer.classList.remove('error');
      responseContainer.classList.remove('success');
      responseContainer.classList.add('info');
    }

    var method = (options.httpMethod) ? options.httpMethod : 'POST';
    var bodyData = requestData;

    if (Array.isArray(requestData)) {
      bodyData = new URLSearchParams();
      requestData.forEach(function(item) {
        if (item && 'name' in item && 'value' in item) {
          bodyData.append(item.name, item.value);
        }
      });
    }

    fetch(url, {
      method: method,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: bodyData
    }).then(function(response) {
      return response.text().then(function(text) {
        var json = null;
        try { json = text ? JSON.parse(text) : null; } catch (e) {}
        var xhrLike = { status: response.status, responseJSON: json };

        var message;
        if (xhrLike.status >= 200 && xhrLike.status < 400) {
          message = (xhrLike.responseJSON && ('message' in xhrLike.responseJSON)) ? xhrLike.responseJSON.message : 'Your request was successfully sent.';
        } else {
          message = (xhrLike.responseJSON && ('message' in xhrLike.responseJSON)) ? xhrLike.responseJSON.message : 'An error occured. Please contact support via email at support@git-tower.com';
        }

        FN.remoteRequest.showResult(xhrLike.status, message, options);

        if(options.onComplete && typeof options.onComplete === 'function'){
          options.onComplete(xhrLike, options);
        }
      });
    }).catch(function() {
      var fallbackMessage = 'An error occured. Please contact support via email at support@git-tower.com';
      FN.remoteRequest.showResult(500, fallbackMessage, options);
      if(options.onComplete && typeof options.onComplete === 'function'){
        options.onComplete({ status: 500, responseJSON: null }, options);
      }
    });
  },
  
  showResult: function(status, message, options){
    var successful = (status >= 200 && status < 400);
    
    if(successful && options.disableButtonOnSuccess){
      var successButton = FN.remoteRequest._resolveElement(options.disableButtonOnSuccess);
      if (successButton) successButton.setAttribute('disabled', 'disabled');
    }
    if(successful && options.disableButtonOnFailure){
      var failureButton = FN.remoteRequest._resolveElement(options.disableButtonOnFailure);
      if (failureButton) failureButton.setAttribute('disabled', 'disabled');
    }
  
    if(options.responseContainer){
      var responseContainer = FN.remoteRequest._resolveElement(options.responseContainer);
      if (responseContainer) {
        responseContainer.innerHTML = message;
        responseContainer.classList.remove('info');
        responseContainer.classList.add((successful ? 'success' : 'error'));
      }
    }
  }
};



/***** Usage example: see newsletter.js */
